export type Theme = "system" | "light" | "dark"
export const DEFAULT_THEME: Theme = "system"
export const THEME_COOKIE = "cendro_theme"
export const THEMES: Theme[] = ["system", "light", "dark"]

export function isTheme(value: string | undefined | null): value is Theme {
  return value === "system" || value === "light" || value === "dark"
}
